import { render } from "./AllSvg.vue?vue&type=template&id=13dc36b8&scoped=true"
import script from "./AllSvg.vue?vue&type=script&lang=js"
export * from "./AllSvg.vue?vue&type=script&lang=js"

import "./AllSvg.vue?vue&type=style&index=0&id=13dc36b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dc36b8"]])

export default __exports__